import React from "react";
import { dateFormat, removeSpace } from "../../utils";
import leftIcon from "../../assets/img/icons/icon_left.png";
import rightIcon from "../../assets/img/icons/icon-right.png";
import Marquee from "react-fast-marquee";
import { encryptData } from "../../utils/storage";
import { Link } from "react-router-dom";

const UpcomingEvents = ({ upcomingeventtable }) => {
  return (
    <>
      <section className="">
        <div className="container-fluid">
          <div className="row y-gap-20 justify-between">
            <div className="col-lg-12 col-sm-12 px-0">
              <article className="main-container__marquee fw-500 text-12 bg-blue-1-05">
                <div className="main-container__marquee-track">
                  <div className="fixed-title text-13 fw-600 px-20 bg-blue-1-05 text-primary">
                    Upcoming Events
                  </div>
                  <Marquee
                    // className="main-container__marquee-items"
                    pauseOnHover
                    autoFill
                    speed={120}
                  >
                    {upcomingeventtable.map((rowdataupd) => {
                      const encryptedParam = encryptData(rowdataupd?.Event_Id);

                      return (
                        <Link
                          to={`/event-details/${removeSpace(
                            rowdataupd.Display_Name
                          )}/${encryptedParam}`}
                          key={`UP${rowdataupd.Event_Id}`}
                        >
                          <span className="main-container__marquee-item">
                            {rowdataupd.Display_Name}{" "}
                            <img
                              className="ml-15 h-20"
                              src={leftIcon}
                              alt="Icon"
                            />
                            <span className="text-primary italic">
                              {rowdataupd.Start_Date}
                            </span>{" "}
                            <img className="h-20" src={rightIcon} alt="Icon" />
                          </span>
                        </Link>
                      );
                    })}
                  </Marquee>
                  {/* <div className="main-container__marquee-items">
                    {upcomingeventtable.map((rowdataupd) => {
                      return (
                        <a href="/" key={`UP${rowdataupd.Event_Id}`}>
                          <span className="main-container__marquee-item">
                            {rowdataupd.Event_Name}{" "}
                            <i className="fas fa-chevron-left text-20 text-primary ml-10"></i>{" "}
                            <span className="text-primary italic ml-10 mr-10">
                              {dateFormat(rowdataupd.Start_Date)}
                            </span>{" "}
                            <i className="fas fa-chevron-right text-20 text-primary"></i>
                          </span>
                        </a>
                      );
                    })}
                  </div>
                  <div
                    aria-hidden="true"
                    className="main-container__marquee-items"
                  >
                    {upcomingeventtable.map((rowdataupd) => {
                      return (
                        <a href="/" key={`UP${rowdataupd.Event_Id}`}>
                          <span className="main-container__marquee-item">
                            {rowdataupd.Event_Name}{" "}
                            <i className="fas fa-chevron-left text-20 text-primary ml-10"></i>{" "}
                            <span className="text-primary italic ml-10 mr-10">
                              {dateFormat(rowdataupd.Start_Date)}
                            </span>{" "}
                            <i className="fas fa-chevron-right text-20 text-primary"></i>
                          </span>
                        </a>
                      );
                    })}
                  </div> */}
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UpcomingEvents;
